<template>
  <div class="qyzx flex">
    <div class="banner flex_1">
      <el-carousel class="my_card" height="400px" v-if="bannerList.length > 0">
        <el-carousel-item v-for="(item, index) in bannerList" :key="index">
          <div class="banner_item flex">
            <img
              v-lazy="
                item?.content_img?.[0]
                  ? `/apis/${item.content_img[0]}`
                  : require('../../../assets/imgs/placeholder/no_img.png')
              "
              alt=""
              class="pointer"
              @click="$goDetail(item)"
            />
            <div
              class="mask text_overflow1 pointer_line"
              @click="$goDetail(item)"
            >
              {{ item.title }}
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
      <img
        v-else
        style="height: 400px; margin: 0 auto"
        src="../../../assets/imgs/placeholder/no_data.png"
        alt=""
      />
    </div>
    <div class="info_list flex_1">
      <div v-if="txtList.length > 0" style="height: 100%">
        <div
          v-for="(item, index) in txtList"
          :key="index"
          class="info_item flex my_card"
        >
          <div class="date fw">
            <div class="day">{{ item.pub_date.slice(-2) }}</div>
            <div class="year_month">
              {{ getData(item.pub_date).slice(0, -3) }}
            </div>
          </div>
          <div class="info_txt flex_1">
            <div
              class="info_title text_overflow1 pointer_line"
              :title="item.title"
              @click="$goDetail(item)"
            >
              {{ item.title }}
            </div>
            <div class="info_desc text_overflow2">
              {{ item.content_text }}
            </div>
          </div>
        </div>
      </div>
      <img
        v-else
        style="height: 400px; margin: 0 auto"
        src="../../../assets/imgs/placeholder/no_data.png"
        alt=""
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "WorkspaceJsonQyzx",
  props: ["list"],
  data() {
    return {
      bannerLength: 3, //指定轮播图长度
    };
  },

  mounted() {},
  computed: {
    bannerList() {
      return this.list.slice(0, this.bannerLength);
    },
    txtList() {
      let len = this.list.length;
      if (len > this.bannerLength) {
        return this.list.slice(this.bannerLength);
      } else {
        return [];
      }
    },
  },
  methods: {
    getData(date) {
      return date ? this.$dayjs(date).format("YYYY-MM-DD") : "";
    },
  },
};
</script>
<style lang='less'>
.el-carousel__indicators {
  li {
    width: 10px;
    height: 10px;
    margin-left: 6px;
    .el-carousel__button {
      width: 10px;
      height: 10px;
      border-radius: 50%;
    }
  }
}
.el-carousel__indicators button {
  background: #317dc7;
}
.el-carousel__indicators--horizontal {
  left: 90% !important;
  bottom: 10px !important;
}
</style>
<style lang="less" scoped>
.qyzx {
  .banner {
    margin-right: 16px;
    /deep/.el-carousel {
      border-radius: 10px;
      overflow: hidden;
    }

    .banner_item {
      height: 100%;

      > img {
        max-width: 100%;
        max-height: 100%;
        margin: auto;
        border-radius: 10px;
      }
      .mask {
        height: 44px;
        line-height: 44px;
        padding-left: 30px;
        padding-right: 100px;
        font-size: 16px;
        color: #f5f5f6;
        background-color: rgba(0, 0, 0, 0.3);
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        border-radius: 0 0 10px 10px;
      }
    }
  }
  .info_list {
    .info_item {
      height: calc((100% - 16px * 2) / 3);
      margin-bottom: 16px;
      padding: 20px;
      &:last-child {
        margin-bottom: 0;
      }
      .date {
        width: 60px;
        margin-right: 12px;
        text-align: center;
        color: #317dc7;
        .day {
          height: 28px;
          line-height: 28px;
          background-color: #e0ecf7;
          font-size: 15px;
        }
        .year_month {
          font-size: 12px;
          height: 25px;
          line-height: 25px;
          background-color: #eff5fb;
        }
      }

      .info_txt {
        .info_title {
          font-size: 16px;
          color: #1d2541;
          line-height: 25px;
        }
        .info_desc {
          font-size: 15px;
          color: #7c8191;
          line-height: 24px;
          padding-top: 8px;
          word-break: break-all;
        }
      }
    }
  }
}
</style>